import { NO_PATTERN_BUSINESS_LOGIC, Link } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { mountComponent } from '../util/mount';
import {
    UnorderedHorizontalList,
    createUnorderedHorizontalList,
} from '@vfde-brix/ws10/unordered-horizontal-list';
import { getCMSConfig } from '../util/cms';
import { JarvisProduct } from '@vfde-sails/avc-core';

export const mountHorizontalList = (wrapperId: HtmlId) =>
    mountComponent(wrapperId, createUnorderedHorizontalList, NO_PATTERN_BUSINESS_LOGIC);

export const updateTariffLinks = (comp?: UnorderedHorizontalList, selectedProduct?: JarvisProduct) => {
    const { productInfo, afterVpProductInfo } = selectedProduct || {};
    const tariffLink = afterVpProductInfo || productInfo;

    if (!comp || !tariffLink) {
        return;
    }

    const props = comp.getProperties();

    if (2 > props.items.length) {
        return;
    }

    const priceListLink: Link = {
        stdLinkUrl: getCMSConfig()?.priceListLink || '',
        optLinkTarget: '_blank',
    };

    const productLink: Link = {
        stdLinkUrl: tariffLink,
        optLinkTarget: '_blank',
    };

    props.items[0].link = priceListLink;
    props.items[1].link = productLink;

    comp.update(props);
};
